import { render, staticRenderFns } from "./PeakFactors.vue?vue&type=template&id=75566674&scoped=true&"
import script from "./PeakFactors.vue?vue&type=script&lang=js&"
export * from "./PeakFactors.vue?vue&type=script&lang=js&"
import style0 from "./PeakFactors.vue?vue&type=style&index=0&id=75566674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75566674",
  null
  
)

export default component.exports